module.exports = __webpack_public_path__ + "static/media/Facebook_Guide_Chin_Android.bd112593.pdf";